import $ from "jquery"
import CryptoJS from "crypto-js";

class shareds {
    //物件建立時產生
    constructor(){

        this.TAIWAN = [
            {
              city: "台北市",
              area: ["中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區"]
            },
            {
              city: "新北市",
              area: ["板橋區", "三重區", "中和區", "永和區", "新莊區", "新店區", "土城區", "蘆洲區", "瑞芳區", "淡水區", "汐止區", "三峽區", "樹林區", "鶯歌區", "五股區", "泰山區", "林口區", "八里區", "平溪區", "雙溪區", "貢寮區", "金山區", "萬里區", "三芝區", "石門區"]
            },
            {
              city: "桃園市",
              area: ["桃園區", "中壢區", "平鎮區", "楊梅區", "蘆竹區", "大溪區", "大園區", "觀音區", "八德區", "龍潭區", "新屋區", "龜山區", "復興區"]
            },
            {
              city: "台中市",
              area: ["中區", "東區", "南區", "西區", "北區", "北屯區", "西屯區", "南屯區", "太平區", "大里區", "霧峰區", "烏日區", "豐原區", "后里區", "石岡區", "東勢區", "和平區", "新社區", "潭子區", "大雅區", "神岡區", "大肚區", "沙鹿區", "龍井區", "梧棲區", "清水區", "大甲區", "外埔區", "大安區"]
            },
            {
              city: "台南市",
              area: ["中西區", "東區", "南區", "北區", "安平區", "安南區", "永康區", "歸仁區", "新化區", "左鎮區", "玉井區", "楠西區", "南化區", "仁德區", "關廟區", "龍崎區", "官田區", "麻豆區", "佳里區", "西港區", "七股區", "將軍區", "學甲區", "北門區", "新營區", "後壁區", "白河區", "東山區", "六甲區", "下營區", "柳營區", "鹽水區", "善化區", "大內區", "山上區", "新市區", "安定區"]
            },
            {
              city: "高雄市",
              area: ["新興區", "前金區", "苓雅區", "鹽埕區", "鼓山區", "旗津區", "前鎮區", "三民區", "楠梓區", "小港區", "左營區", "仁武區", "大社區", "岡山區", "路竹區", "阿蓮區", "田寮區", "燕巢區", "橋頭區", "梓官區", "彌陀區", "永安區", "湖內區", "鳳山區", "大寮區", "林園區", "鳥松區", "大樹區", "旗山區", "美濃區", "六龜區", "內門區", "杉林區", "甲仙區", "桃源區", "那瑪夏區", "茂林區", "茄萣區"]
            },
            {
              city: "基隆市",
              area: ["中正區", "七堵區", "暖暖區", "仁愛區", "中山區", "安樂區", "信義區"]
            },
            {
              city: "新竹市",
              area: ["東區", "北區", "香山區"]
            },
            {
              city: "嘉義市",
              area: ["東區", "西區"]
            },
            {
              city: "新竹縣",
              area: ["竹北市", "竹東鎮", "新埔鎮", "關西鎮", "湖口鄉", "新豐鄉", "芎林鄉", "橫山鄉", "北埔鄉", "寶山鄉", "峨眉鄉", "尖石鄉", "五峰鄉"]
            },
            {
              city: "苗栗縣",
              area: ["苗栗市", "頭份市", "竹南鎮", "後龍鎮", "通霄鎮", "苑裡鎮", "卓蘭鎮", "造橋鄉", "西湖鄉", "頭屋鄉", "公館鄉", "銅鑼鄉", "三義鄉", "大湖鄉", "獅潭鄉", "三灣鄉", "南庄鄉", "泰安鄉"]
            },
            {
              city: "彰化縣",
              area: ["彰化市", "員林市", "和美鎮", "鹿港鎮", "溪湖鎮", "二林鎮", "田中鎮", "北斗鎮", "花壇鄉", "芬園鄉", "大村鄉", "永靖鄉", "伸港鄉", "線西鄉", "福興鄉", "秀水鄉", "埔心鄉", "埔鹽鄉", "大城鄉", "芳苑鄉", "竹塘鄉", "社頭鄉", "二水鄉", "田尾鄉", "埤頭鄉", "溪州鄉"]
            },
            {
              city: "南投縣",
              area: ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"]
            },
            {
              city: "雲林縣",
              area: ["斗六市", "斗南鎮", "虎尾鎮", "西螺鎮", "土庫鎮", "北港鎮", "莿桐鄉", "林內鄉", "古坑鄉", "大埤鄉", "崙背鄉", "二崙鄉", "麥寮鄉", "臺西鄉", "東勢鄉", "褒忠鄉", "四湖鄉", "口湖鄉", "水林鄉", "元長鄉"]
            },
            {
              city: "嘉義縣",
              area: ["太保市", "朴子市", "布袋鎮", "大林鎮", "民雄鄉", "溪口鄉", "新港鄉", "六腳鄉", "東石鄉", "義竹鄉", "鹿草鄉", "水上鄉", "中埔鄉", "竹崎鄉", "梅山鄉", "番路鄉", "大埔鄉", "阿里山鄉"]
            },
            {
              city: "屏東縣",
              area: ["屏東市", "潮州鎮", "東港鎮", "恆春鎮", "萬丹鄉", "長治鄉", "麟洛鄉", "九如鄉", "里港鄉", "鹽埔鄉", "高樹鄉", "萬巒鄉", "內埔鄉", "竹田鄉", "新埤鄉", "枋寮鄉", "新園鄉", "崁頂鄉", "林邊鄉", "南州鄉", "佳冬鄉", "琉球鄉", "車城鄉", "滿州鄉", "枋山鄉", "三地門鄉", "霧臺鄉", "瑪家鄉", "泰武鄉", "來義鄉", "春日鄉", "獅子鄉", "牡丹鄉"]
            },
            {
              city: "宜蘭縣",
              area: ["宜蘭市", "羅東鎮", "蘇澳鎮", "頭城鎮", "礁溪鄉", "壯圍鄉", "員山鄉", "冬山鄉", "五結鄉", "三星鄉", "大同鄉", "南澳鄉"]
            },
            {
              city: "花蓮縣",
              area: ["花蓮市", "鳳林鎮", "玉里鎮", "新城鄉", "吉安鄉", "壽豐鄉", "秀林鄉", "光復鄉", "豐濱鄉", "瑞穗鄉", "萬榮鄉", "富里鄉"]
            },
            {
              city: "台東縣",
              area: ["台東市", "成功鎮", "關山鎮", "卑南鄉", "鹿野鄉", "池上鄉", "東河鄉", "長濱鄉", "太麻里鄉", "大武鄉", "綠島鄉", "海端鄉", "延平鄉", "金峰鄉", "達仁鄉", "蘭嶼鄉"]
            },
            {
              city: "澎湖縣",
              area: ["馬公市", "湖西鄉", "白沙鄉", "西嶼鄉", "望安鄉", "七美鄉"]
            },
            {
              city: "金門縣",
              area: ["金城鎮", "金湖鎮", "金沙鎮", "金寧鄉", "烈嶼鄉", "烏坵鄉"]
            },
            {
              city: "連江縣",
              area: ["南竿鄉", "北竿鄉", "莒光鄉", "東引鄉"]
            }
        ]

        this.weekdays = ['日', '一', '二', '三', '四', '五', '六'];
    }

    
    /**********
     * 檢查物件是否不存在
     * obj : any object
     */
    isEmpty = (obj) => {
        if(
            typeof obj == 'undefined'
            || obj == null
            || obj.length<=0
        ){
            return true;
        }
        return false;
    }

    //  判斷是否為空物件
    isEmptyObject(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }


    getRotationAngles(degrees) {
      // 將角度轉換為弧度
      const radians = (degrees * Math.PI) / 180;

      // 返回對應的弧度值
      return radians;
    }

    urlSafeBase64Decode(base64) {
      // 將 URL-safe Base64 替換回普通 Base64
      let base64Str = base64.replace(/-/g, '+').replace(/_/g, '/');
      
      // 補全 Base64 字串的 `=` 填充
      const padding = base64Str.length % 4;
      if (padding > 0) {
          base64Str += '='.repeat(4 - padding);
      }
      
      // 使用 atob 解碼
      return atob(base64Str);
    }

    setProjectPageHeader(data={title:'AUU',ico: 'public/favicon.ico' }){
      document.title = data.title || 'AUU';
      // 使用 require 來加載圖片，確保打包後的路徑正確
      const favicon = data.ico || '/public/favicon.ico';
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
          link.href = favicon;
      } else {
          const newLink = document.createElement('link');
          newLink.rel = 'icon';
          newLink.href = favicon;
          document.head.appendChild(newLink);
      }
  }

}
export default shareds